import { render, staticRenderFns } from "./OrganizationConfig.vue?vue&type=template&id=6c6bd881&"
import script from "./OrganizationConfig.vue?vue&type=script&lang=js&"
export * from "./OrganizationConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports